export default "__VITE_ASSET__363ae1a4__"